module.exports = __webpack_public_path__ + "img/live-conduct.5c504e37.gif";